/*================DOB validation Directive
 ==========================================*/
/*
 *
 * place data-valid-birth-date inside the input field
 * <input type="text" id="" name="" data-valid-birth-date>
 *
 */
angular
.module('vppApp')
.directive('validBirthDate', function () {
  return {
    restrict: "A",
    require: "ngModel",
    link: function (scope, element, attributes, ngModel) {
      ngModel.$validators.validBirthDate = function (ngModelValue) {

        function isValidDate(_mm, _dd, _yyyy) {
          // Assume not leap year by default (note zero index for Jan)
          var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
          // If evenly divisible by 4 and not evenly divisible by 100,
          // or is evenly divisible by 400, then a leap year
          if ((!(_yyyy % 4) && _yyyy % 100) || !(_yyyy % 400)) {
            daysInMonth[1] = 29;
          }
          return !(/\D/.test(String(_dd))) && _dd > 0 && _dd <= daysInMonth[--_mm];
        }

        // only validate if the field has a value
        if(ngModelValue != '') {
          var _mm = ngModelValue.substr(0, 2);
          var _dd = ngModelValue.substr(2, 2);
          var _yyyy = ngModelValue.substr(4, 4);

          if (/^(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])(19|20)\d\d$/.test(ngModelValue) && isValidDate(_mm, _dd, _yyyy)) {
            return true;
          }
          return false;
        } else {
          return true;
        }
      };
    }
  };
});
